import { render, staticRenderFns } from "./TalimatTanimla.vue?vue&type=template&id=cc2457f4&"
import script from "./TalimatTanimla.vue?vue&type=script&lang=js&"
export * from "./TalimatTanimla.vue?vue&type=script&lang=js&"
import style0 from "./TalimatTanimla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports